import logoMivo from "@/assets/logo_mivo.png";
import { FeatureItem } from "@/components/auth/FeatureItem";
import { BRAND_SECTION_TRANSLATIONS } from "@/components/auth/authShellConstants";
import { MarketingSiteLink } from "@mivo/ui/MarketingSiteLink";
import { getTranslation } from "@mivo/i18n";
import { Heart, ShieldCheck, Users } from "lucide-react";
import MivoWordMark from "../MivoWordMark";

/** Marketing panel for auth pages (desktop left column). */
export function BrandSection() {
    const features = [
        {
            icon: ShieldCheck,
            title: getTranslation(BRAND_SECTION_TRANSLATIONS.featureSecureTitle),
            description: getTranslation(BRAND_SECTION_TRANSLATIONS.featureSecureDescription),
        },
        {
            icon: Users,
            title: getTranslation(BRAND_SECTION_TRANSLATIONS.featureAccompaniedTitle),
            description: getTranslation(BRAND_SECTION_TRANSLATIONS.featureAccompaniedDescription),
        },
        {
            icon: Heart,
            title: getTranslation(BRAND_SECTION_TRANSLATIONS.featureHumanTitle),
            description: getTranslation(BRAND_SECTION_TRANSLATIONS.featureHumanDescription),
        },
    ] as const;

    return (
        <div className="relative flex min-h-full w-full items-center justify-center p-6 lg:p-12">
            <div className="flex w-full max-w-lg flex-col items-center justify-center gap-10 text-center">
                <MarketingSiteLink
                    data-testid="brand-home-link"
                    aria-label={getTranslation(BRAND_SECTION_TRANSLATIONS.homeAriaLabel)}
                >
                    <div className="flex items-center gap-2">
                        <img src={logoMivo} alt="Mivo" style={{ width: "80px", height: "auto" }} />
                        <div className="relative top-[6.6px]">
                            <MivoWordMark fontSize="65px" />
                        </div>
                    </div>
                </MarketingSiteLink>

                <div className="relative z-10 flex flex-col items-center justify-center gap-3 px-4 sm:px-6">
                    <h1 className="text-balance font-display text-3xl font-bold leading-tight tracking-tight text-foreground xl:text-4xl">
                        {getTranslation(BRAND_SECTION_TRANSLATIONS.headline)}
                    </h1>
                    <p className="font-display text-lg font-semibold text-primary">
                        {getTranslation(BRAND_SECTION_TRANSLATIONS.subhead)}
                    </p>
                    <p className="max-w-md text-sm leading-relaxed text-muted-foreground">
                        {getTranslation(BRAND_SECTION_TRANSLATIONS.body)}
                    </p>
                </div>

                <div data-testid="brand-features" className="flex w-full justify-center">
                    <div className="relative z-10 flex w-full max-w-md flex-col gap-4 rounded-xl bg-card p-4 text-left ring-1 ring-foreground/10">
                        {features.map((feature) => (
                            <FeatureItem key={feature.title} {...feature} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
